import * as fromReports from '@ndt/reports/shared/state/reports.reducer';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';
import * as fromAppStart from './app-start/app-start.reducer';
import * as fromAuthentication from './authentication/state/authentication.reducer';
import * as fromAccountOptions from './common-components/entity-select/account/state/account-option.reducer';
import * as fromCallRetentionPolicyOptions from './common-components/entity-select/call-retention-policy/state/call-retention-policy-option.reducer';
import * as fromDayOfWeekOptions from './common-components/entity-select/day-of-week/state/day-of-week-option.reducer';
import * as fromDepartmentOptions from './common-components/entity-select/department/state/department-option.reducer';
import * as fromDeviceTypeOptions from './common-components/entity-select/device-type/state/device-type-option.reducer';
import * as fromExtensionGroupOptions from './common-components/entity-select/extension-group/state/extension-group-option.reducer';
import * as fromExtensionTypeOptions from './common-components/entity-select/extension-type/state/extension-type-option.reducer';
import * as fromExtensionAutoAttendantOptions from './common-components/entity-select/extension/state/extension-option-reducers/extension-autoattendant-option.reducer';
import * as fromExtensionHuntGroupOptions from './common-components/entity-select/extension/state/extension-option-reducers/extension-huntgroup-option.reducer';
import * as fromExtensionQueueOptions from './common-components/entity-select/extension/state/extension-option-reducers/extension-queue-option.reducer';
import * as fromExtensionOptions from './common-components/entity-select/extension/state/extension-option.reducer';
import * as fromFaxFileTypeOptions from './common-components/entity-select/fax-file-type/state/fax-file-type-option.reducer';
import * as fromFaxStatusOptions from './common-components/entity-select/fax-status/state/fax-status-option.reducer';
import * as fromFaxTypeOptions from './common-components/entity-select/fax-type/state/fax-type-option.reducer';
import * as fromLocationOptions from './common-components/entity-select/location/state/location-option.reducer';
import * as fromLogLevelOptions from './common-components/entity-select/log-level/state/log-level-option.reducer';
import * as fromNameDirectoryPreferenceOptions from './common-components/entity-select/name-directory-preference/state/name-directory-preference-option.reducer';
import * as fromDeviceOptions from './common-components/entity-select/phone/state/device-option.reducer';
import * as fromPhoneNumberOptions from './common-components/entity-select/phonenumber/state/phone-number-option.reducer';
import * as fromPhoneOptions from './common-components/entity-select/phones/state/phone-option.reducer';
import * as fromPromptTypeOptions from './common-components/entity-select/prompt-type/state/prompt-type-option.reducer';
import * as fromPromptOptions from './common-components/entity-select/prompt/state/prompt-option.reducer';
import * as fromQueueManagementStrategyOptions from './common-components/entity-select/queue-management/state/queue-management-option.reducer';
import * as fromRoleOptions from './common-components/entity-select/role/state/role-option.reducer';
import * as fromScheduleOptions from './common-components/entity-select/schedule/state/schedule-option.reducer';
import * as fromServerOptions from './common-components/entity-select/server/state/server-option.reducer';
import * as fromSystemLogAreaOptions from './common-components/entity-select/system-log-area/state/system-logs-area-select-option.reducer';
import * as fromSystemLogTypeOptions from './common-components/entity-select/system-log-type/state/system-logs-type-select-option.reducer';
import * as fromSystemLogSeverityOptions from './common-components/entity-select/system-logs-severity/state/system-logs-severity-select-option.reducer';
import * as fromTimeZoneOptions from './common-components/entity-select/timezone/state/time-zone-option.reducer';
import * as fromUserOptions from './common-components/entity-select/user/state/user-option.reducer';
import { reducer, State } from './store/select-account/select-account.reducer';

export interface AppState {
   appStart: fromAppStart.AppStartState;
   accountOptions: fromAccountOptions.AccountOptionState;
   authentication: fromAuthentication.AuthenticationState;
   callRetentionPolicyOptions: fromCallRetentionPolicyOptions.CallRetentionPolicyOptionState;
   dayOfWeekOptions: fromDayOfWeekOptions.DayOfWeekOptionState;
   deviceOptions: fromDeviceOptions.DeviceOptionState;
   extensionOptions: fromExtensionOptions.ExtensionOptionState;
   extensionQueueOptions: fromExtensionQueueOptions.ExtensionQueuesOptionState;
   extensionAutoAttendantOptions: fromExtensionAutoAttendantOptions.ExtensionAutoAttendantOptionState;
   extensionHuntGroupOptions: fromExtensionHuntGroupOptions.ExtensionHuntGroupsOptionState;
   extensionGroupOptions: fromExtensionGroupOptions.ExtensionGroupOptionState;
   extensionTypeOptions: fromExtensionTypeOptions.ExtensionTypeOptionState;
   departmentOptions: fromDepartmentOptions.DepartmentOptionState;
   deviceTypeOptions: fromDeviceTypeOptions.DeviceTypeOptionState;
   timeZoneOptions: fromTimeZoneOptions.TimeZoneOptionState;
   queueManagementStrategyOptions: fromQueueManagementStrategyOptions.QueueManagementStrategyOptionState;
   nameDirectoryPreferenceOptions: fromNameDirectoryPreferenceOptions.nameDirectoryPreferenceOptionState;
   phoneOptions: fromPhoneOptions.PhoneOptionState;
   phoneNumberOptions: fromPhoneNumberOptions.PhoneNumberOptionState;
   faxTypeOptions: fromFaxTypeOptions.FaxTypeOptionState;
   faxStatusOptions: fromFaxStatusOptions.FaxStatusOptionState;
   promptTypeOptions: fromPromptTypeOptions.PromptTypeOptionState;
   promptOptions: fromPromptOptions.PromptOptionState;
   scheduleOptions: fromScheduleOptions.ScheduleOptionState;
   serverOptions: fromServerOptions.ServerOptionState;
   systemLogAreaOptions: fromSystemLogAreaOptions.SystemLogAreaOptionState;
   systemLogSeverityOptions: fromSystemLogSeverityOptions.SystemLogSeverityOptionState;
   systemLogTypeOptions: fromSystemLogTypeOptions.SystemLogTypeOptionState;
   locationOptions: fromLocationOptions.LocationOptionState;
   logLevelOptions: fromLogLevelOptions.LogLevelOptionState;
   faxFileTypeOptions: fromFaxFileTypeOptions.FaxFileTypeOptionState;
   userOptions: fromUserOptions.UserOptionState;
   roleOptions: fromRoleOptions.RoleOptionState;
   router: RouterReducerState<any>;
   reports: fromReports.State;
   selectAccountCore: State;
}

export const reducers: ActionReducerMap<AppState> = {
   accountOptions: fromAccountOptions.accountOptionsReducer,
   appStart: fromAppStart.appStartReducer,
   authentication: fromAuthentication.reducer,
   callRetentionPolicyOptions: fromCallRetentionPolicyOptions.callRetentionPolicyOptionsReducer,
   dayOfWeekOptions: fromDayOfWeekOptions.dayOfWeekOptionsReducer,
   deviceOptions: fromDeviceOptions.deviceOptionsReducer,
   extensionOptions: fromExtensionOptions.extensionOptionsReducer,
   extensionQueueOptions: fromExtensionQueueOptions.extensionQueueOptionsReducer,
   extensionAutoAttendantOptions: fromExtensionAutoAttendantOptions.extensionAutoAttendantOptionsReducer,
   extensionHuntGroupOptions: fromExtensionHuntGroupOptions.extensionHuntGroupOptionsReducer,
   extensionGroupOptions: fromExtensionGroupOptions.extensionGroupOptionsReducer,
   extensionTypeOptions: fromExtensionTypeOptions.extensionTypeOptionsReducer,
   deviceTypeOptions: fromDeviceTypeOptions.deviceTypeOptionsReducer,
   departmentOptions: fromDepartmentOptions.departmentOptionsReducer,
   locationOptions: fromLocationOptions.locationOptionsReducer,
   logLevelOptions: fromLogLevelOptions.logLevelOptionsReducer,
   faxFileTypeOptions: fromFaxFileTypeOptions.faxFileTypeOptionsReducer,
   nameDirectoryPreferenceOptions: fromNameDirectoryPreferenceOptions.nameDirectoryPreferenceOptionsReducer,
   phoneOptions: fromPhoneOptions.phoneOptionsReducer,
   phoneNumberOptions: fromPhoneNumberOptions.phoneNumberOptionsReducer,
   promptOptions: fromPromptOptions.promptOptionsReducer,
   faxTypeOptions: fromFaxTypeOptions.faxTypeOptionsReducer,
   faxStatusOptions: fromFaxStatusOptions.faxStatusOptionsReducer,
   promptTypeOptions: fromPromptTypeOptions.promptTypeOptionsReducer,
   reports: fromReports.reducer,
   roleOptions: fromRoleOptions.roleOptionsReducer,
   router: routerReducer,
   scheduleOptions: fromScheduleOptions.scheduleOptionsReducer,
   selectAccountCore: reducer,
   serverOptions: fromServerOptions.serverOptionsReducer,
   systemLogAreaOptions: fromSystemLogAreaOptions.systemLogAreaOptionsReducer,
   systemLogSeverityOptions: fromSystemLogSeverityOptions.systemLogSeverityOptionsReducer,
   systemLogTypeOptions: fromSystemLogTypeOptions.systemLogTypeOptionsReducer,
   timeZoneOptions: fromTimeZoneOptions.timeZoneTypeOptionsReducer,
   queueManagementStrategyOptions: fromQueueManagementStrategyOptions.queueManagementStrategyOptionsReducer,
   userOptions: fromUserOptions.userOptionsReducer,
};
